import { version, useId } from 'react';

// Now use react 18 hook to generate UUID
var useCanvasId = function useCanvasId(id, prependString) {
  // if user passes an ID in just use that and dont generate a new id
  if (id) {
    return id;
  }

  // fallback if a app doesn't use react 18 or greater
  if (version.slice(0, 2) < 18) {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
      return "".concat(prependString ? prependString : 'canvasId', "_").concat(v.toString(16));
    });
  }

  // useId returns a unique ID string associated with this particular useId call in this particular component.
  // eslint-disable-next-line
  var canvasUUID = "".concat(prependString ? prependString : 'canvasId', "_").concat(useId());
  return canvasUUID;
};

export { useCanvasId as default };
